export enum NotificationVariant {
    Success = "success",
    Error = "error",
}
